import React, { useState, useEffect } from "react";

export default function StickySection() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const headline1 = (
    <>
      20 years as an<br />
      Art Director. IKEA.  <br />
      VW. Die PARTEI. 200+<br />
      awards. You get it.
    </>
  );

  const headline2 = (
    <>
      In 2019, I co-founded<br />
      Karada House,<br />
      a queer art space.
    </>
  );

  if (isMobile) {
    return (
      <section className="bg-black">
        {/* Section 1 */}
        <div className="flex flex-col">
          <div className="w-full flex-1 flex items-center justify-center overflow-hidden" style={{ minHeight: "50vw" }}>
            <img
              src="/images/sticky-diepartei.webp"
              alt="Die PARTEI iDemo campaign by Renée Gebhardt: guerilla political advertising on Berlin streets"
              style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
            />
          </div>
          <div
            className="w-full flex-1 flex items-start justify-center bg-black"
            style={{ padding: "0 15px", paddingTop: "100px", paddingBottom: "120px" }}
          >
            <div className="text-center">
              <h2
                className="heading-sticky mb-4"
                style={{
                  fontSize: "clamp(36px, 7vw, 42px)",
                  color: "#71717a",
                  textTransform: "uppercase",
                  lineHeight: "1",
                }}
              >
                {headline1}
              </h2>
              <p className="body-large" style={{ fontSize: "18px", lineHeight: "1.5" }}>
                I don't separate commercial from cultural work. From ads to films
              to cultural spaces. I make work that people talk about the next day 
              – sometimes through storytelling, sometimes through experience,
              often both.
              </p>
            </div>
          </div>
        </div>

        {/* Section 2 */}
        <div className="flex flex-col">
          <div className="w-full flex-1 flex items-center justify-center overflow-hidden" style={{ minHeight: "50vw" }}>
            <img
              src="/images/sticky-karada.webp"
              alt="Karada House Berlin: queer kink and art space in a former church in Moabit, co-founded by Renée Gebhardt"
              style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
            />
          </div>
          <div
            className="w-full flex-1 flex items-start justify-center bg-black"
            style={{ padding: "0 15px", paddingTop: "100px", paddingBottom: "80px" }}
          >
            <div className="text-center">
              <h2
                className="heading-sticky mb-4"
                style={{
                  fontSize: "clamp(36px, 7vw, 42px)",
                  color: "#71717a",
                  textTransform: "uppercase",
                  lineHeight: "1",
                }}
              >
                {headline2}
              </h2>
              <p className="body-large" style={{ fontSize: "18px", lineHeight: "1.5" }}>
              Over six years, it became a vibrant community. I stopped asking,
              ”Will this succeed?“ and started asking, ”Who does it affect?“
              Good work survives the people it touches, not the paper it’s written on.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-black">
      {/* Section 1 – Bild links, Text rechts */}
      <div className="flex" style={{ minHeight: "80vh" }}>
        <div className="w-1/2 overflow-hidden">
          <img
            src="/images/sticky-diepartei.webp"
            alt="Die PARTEI iDemo campaign by Renée Gebhardt: guerilla political advertising on Berlin streets"
            style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
          />
        </div>
        <div className="w-1/2 flex items-center justify-center bg-black" style={{ padding: "80px clamp(32px, 4vw, 80px)" }}>
          <div style={{ width: "clamp(280px, 85%, 680px)" }}>
            <h2
              style={{
                marginBottom: "56px",
                color: "#71717a",
                textTransform: "uppercase",
                fontFamily: "Archivo, sans-serif",
                fontVariationSettings: '"wdth" 80, "wght" 750',
                fontSize: "clamp(24px, 3.3vw, 72px)",
                lineHeight: "0.95",
              }}
            >
              <b>{headline1}</b>
            </h2>
            <p style={{ fontSize: "clamp(16px, 1.2vw, 22px)", lineHeight: "1.6", color: "#d4d4d8" }}>
              I don't separate commercial from cultural work. From ads to films
              to cultural spaces. I make work that people talk about the next day 
              – sometimes through storytelling, sometimes through experience,
              often both.
            </p>
          </div>
        </div>
      </div>

      {/* Section 2 – Text links, Bild rechts */}
      <div className="flex" style={{ minHeight: "80vh" }}>
        <div className="w-1/2 flex items-center justify-center bg-black" style={{ padding: "80px clamp(32px, 4vw, 80px)" }}>
          <div style={{ width: "clamp(280px, 85%, 680px)" }}>
            <h2
              style={{
                marginBottom: "56px",
                color: "#71717a",
                textTransform: "uppercase",
                fontFamily: "Archivo, sans-serif",
                fontVariationSettings: '"wdth" 80, "wght" 750',
                fontSize: "clamp(24px, 3.3vw, 72px)",
                lineHeight: "0.95",
              }}
            >
              <b>{headline2}</b>
            </h2>
            <p style={{ fontSize: "clamp(16px, 1.2vw, 22px)", lineHeight: "1.6", color: "#d4d4d8" }}>
              Over six years, it became a vibrant community. I stopped asking,
              ”Will this succeed?“ and started asking, ”Who does it affect?“
              Good work survives the people it touches, not the paper it’s written on.
            </p>
          </div>
        </div>
        <div className="w-1/2 overflow-hidden">
          <img
            src="/images/sticky-karada.webp"
            alt="Karada House Berlin: queer kink and art space in a former church in Moabit, co-founded by Renée Gebhardt"
            style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
          />
        </div>
      </div>
    </section>
  );
}